import { render, staticRenderFns } from "./RightColumnAds.vue?vue&type=template&id=2b7ee7c6&scoped=true&"
import script from "./RightColumnAds.vue?vue&type=script&lang=js&"
export * from "./RightColumnAds.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnAds.vue?vue&type=style&index=0&id=2b7ee7c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ee7c6",
  null
  
)

export default component.exports